import { makeAutoObservable, runInAction } from 'mobx'
import { apiService } from '@/services/Api'
import { Country } from '@/services/Api/generated'

export class CountriesStore {
  list: Country[] = []

  async get() {
    if (this.list.length !== 0) {
      return this.list
    }
    const response = await apiService.dictionary.getCountries()
    if (response.status) {
      runInAction(() => {
        this.list = response.data
      })
    }
    return this.list
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }
}
